import type { Invoice } from "@/lib/invoice.api";
import type { DocumentTone } from "@/pages/documents/components/DocumentWorkspace";

export type InvoiceViewMode = "table" | "grid";
export type InvoiceStatusFilter = "all" | Invoice["status"];
export type InvoicePaymentFilter = "all" | Invoice["paymentStatus"];

export const INVOICES_PAGE_GUIDE = [
  "Recherchez ou filtrez les factures par statut de paiement.",
  "« Facture directe » crée un brouillon direct, sans passer par une proforma.",
  "Cliquez sur une facture pour enregistrer un paiement ou consulter son détail.",
];

export const STATUS_LABELS: Record<Invoice["status"], string> = {
  draft: "Brouillon",
  issued: "Émise",
  expired: "Expirée",
  cancelled: "Annulée",
};

export const STATUS_TONES: Record<Invoice["status"], DocumentTone> = {
  draft: "warning",
  issued: "success",
  expired: "warning",
  cancelled: "danger",
};

export const PAYMENT_LABELS: Record<Invoice["paymentStatus"], string> = {
  unpaid: "Impayée",
  partial: "Partielle",
  paid: "Payée",
};

export const PAYMENT_TONES: Record<Invoice["paymentStatus"], DocumentTone> = {
  unpaid: "danger",
  partial: "warning",
  paid: "success",
};
